import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { useSelector } from '#/reduxState/store';

const Wrap = styled.div<{ $mobilePadding?: string }>`
  display: inline-grid;
  overflow-y: auto;
  grid-template-rows: 1fr;
  align-items: center;
  width: 100%;
  padding: 16px;
  height: calc(100% - var(--mobileNavHeight));
  ${({ $mobilePadding }) =>
    $mobilePadding ? `padding: ${$mobilePadding};` : undefined}
`;

/**
 * Verically centered box used on mobile.
 * It automatically exclude height of header to calculate it's height.
 */
export default function ScrollableMobileCenteredBox({
  children,
  mobilePadding,
}: {
  children: ReactNode;
  mobilePadding?: string;
}) {
  const isMobile = useSelector(state => state.screen.isMobile);
  if (!isMobile) {
    return <>{children}</>;
  }
  return <Wrap $mobilePadding={mobilePadding}>{children}</Wrap>;
}
